import React, {useEffect, useState} from 'react';
import HeaderComponent from "../../component/base/header-component/HeaderComponent";
import FooterComponent from "../../component/base/footer-component/FooterComponent";
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import {isShowFeedback, isShowWarningDialogPleaseCheckYourDataUsage} from "../../store/UserStore";
import OnboardDialog from "../../component/base/onboard-dialog-component/OnboardDialog";
import {firstCharacterUpper} from "../../util/CharacterUtil";
import NoPackageIcon from "../../assets/images/no-package.webp";
import parse from 'html-react-parser';
import OnboardOrLine from "../../component/base/onboard-or-line-component/OnboardOrLine";
import PowerSavingModeIntroductionComponent
    from "../../component/base/onboard-power-saving-mode-introduction-component/PowerSavingModeIntroductionComponent";
import {getUserStatus} from "../../example/getUserStatus";
import VerifyTypeEnum from "../../enum/VerifyTypeEnum";
import {
    againRequestAccessInternetPopup,
    dialogMaxConcurrentSessionLimitIsReached,
    dialogUserIdExistsWithDifferentIp
} from "../../util/InternetAccessRequestExceptionHandle";
import OnboardTotalQouta from "../../component/base/onboard-total-qouta-component/OnboardTotalQouta";
import OnboardTwoButtons from "../../component/base/onboard-two-buttons-component/OnboardTwoButtons";
import {ICON_TYPE} from "../../component/base/onboard-dialog-dynamic-component/OnboardDialogDynamic";
import Const from "../../constant/Const";
import RemainingUsageManager from "../../util/RemainingUsageManager";
import {setSimulationNumber} from '../../util/SimulationManager';
import {useRecoilValue} from 'recoil';
import {informationAtom} from '../../store/InformationStore';

const RemainingUsagePage = (props) => {
    const {t, i18n, navigate, flight, user, setLoading, setDialogDynamic, handleInformation, location} = props.props;
    const information = useRecoilValue(informationAtom);

    const simulationNumber = setSimulationNumber();
    const isSimulation = setSimulationNumber();
    const [disconnectVisible, setDisconnectVisible] = useState(false);
    const [endSessionVisible, setEndSessionVisible] = useState(false);
    const [disconnectExceptionVisible, setDisconnectExceptionVisible] = useState(false);
    const [endSessionExceptionVisible, setEndSessionExceptionVisible] = useState(false);
    const [resumeExceptionVisible, setResumeExceptionVisible] = useState(false);
    const [warningVisible, setWarningVisible] = useState(false);
    const [informationVisible, setInformationVisible] = useState(false);
    const [definedTitleVisible, setDefinedTitleVisible] = useState(false);
    const [purchaseTitleVisible, setPurchaseTitleVisible] = useState(false);
    const [favorTitleVisible, setFavorTitleVisible] = useState(false);
    const [campaignTitleVisible, setCampaignTitleVisible] = useState(false);
    const [resumeInternetVisible, setResumeInternetVisible] = useState(false);

    const [qoutaRemainingMB, setQoutaRemainingMB] = useState("-");
    const [qoutaRemainingTotalMB, setQoutaRemainingTotalMB] = useState("-");
    const [qoutaIsUnlimitedInternet, setQoutaIsUnlimitedInternet] = useState(false);
    const [qoutaIsUnlimitedMessage, setQoutaIsUnlimitedMessage] = useState(false);
    const [qoutaRemainingTime, setQoutaRemainingTime] = useState("--:--");
    const [qoutaLoading, setQoutaLoading] = useState(true);

    const {
        hasPackages,
        getContentManager,
        hasInternetPackage,
        hasInternetPackageUnlimited,
        getQoutaRemainingTime,
        renderDefinedRightsPackages,
        renderFavorPackages,
        renderCampaignPackages,
        renderPurchasePackages
    } = new RemainingUsageManager(user, t, i18n);

    useEffect(() => {
        checkInternetAccessRequest();
        showTitle(user.quotas);
        getQuotaRemaining(false);
        if (!isSimulation)
            feedbackCountCheckShow();

        if (information.simulationNumber === 12 && information.simulationStep === 1)
            simulationNumber(1, 2);

        if (information.simulationNumber === 3 && information.simulationStep === 3)
            simulationNumber(4, 3);

        if (information.simulationNumber === 6 && information.simulationStep === 3)
            simulationNumber(7, 3);

        if (information.simulationNumber === 10 && information.simulationStep === 3)
            simulationNumber(11, 3);

        if (information.simulationNumber === 5 && information.simulationStep === 4)
            simulationNumber(6, 4);

        if (information.simulationNumber === 9 && information.simulationStep === 4)
            simulationNumber(10, 4);

        if (hasPackage())
            handleInformation("remaining_usage_1");
        else
            handleInformation("remaining_usage_0");
    }, []);

    const feedbackCountCheckShow = () => {
        if (isShowFeedback()) {
            showPopupFeedback();
        }
    }

    const getQuotaRemaining = (loading) => {
        if (hasPackage() && !isLoginOtherLogin()) {
            if (loading) setLoading(true);
            let res = getUserStatus;
            if (loading) setLoading(false);
            if (res.data !== undefined && res.data?.data !== undefined &&
                res.data?.data !== null && res.data?.data?.respCode === 0) {
                if (res.data?.data.internetAccessState === "STOPPED") {
                    setResumeInternetVisible(true);
                }
                handleQoutaRemaining(res.data?.data?.userQuotaList);
            }
            setQoutaLoading(false);
            setQoutaIsUnlimitedInternet(hasInternetPackageUnlimited());
        } else if (isLoginOtherLogin()) {
            setQoutaIsUnlimitedInternet(hasInternetPackageUnlimited());
            setQoutaLoading(false);
        } else {
            setQoutaLoading(false);
        }
    }

    const handleQoutaRemaining = (list) => {
        let totalMB = 0;
        let remainingMB = 0;
        list?.forEach(data => {
            if (data?.userQuotaType === 'TIME' && data?.userQuotaName?.toLowerCase()?.indexOf("chat") >= 0) {
                setQoutaIsUnlimitedMessage(true);
            } else if (data?.userQuotaType === 'VOLUME') {
                remainingMB = remainingMB + parseInt(data?.remainingQuotaAmount);
                totalMB = totalMB + parseInt(data?.initialQuotaAmount);
                setQoutaRemainingMB(remainingMB);
                setQoutaRemainingTotalMB(totalMB);
                setQoutaRemainingTime(getQoutaRemainingTime(data?.validityEnd));
            }
        });
    }

    const checkInternetAccessRequest = () => {
        if (user.internetAccessRequest === 3) {
            againRequestAccessInternetPopup(setDialogDynamic, t);
        } else if (user.internetAccessRequest === 2) {
            dialogUserIdExistsWithDifferentIp(setDialogDynamic, t, navigate);
        } else if (user.internetAccessRequest === 1) {
            dialogMaxConcurrentSessionLimitIsReached(setDialogDynamic, t, undefined, navigate, setLoading);
        } else {
            setWarningVisible(isShowWarningDialogPleaseCheckYourDataUsage());
        }
    }

    const handlePurchaseButtonVisible = () => {
        return !hasInternetPackageUnlimited();
    }

    const handlePackageBuyButtonVisible = () => {
        if (location.pathname === '/simulation') return true;
        return handlePurchaseButtonVisible();
    }

    const showTitle = (data) => {
        if (data === null) return;
        if (data.nonPurchase?.length > 0)
            setDefinedTitleVisible(true);
        if (data.purchase?.length > 0)
            setPurchaseTitleVisible(true);
        if (data.favor?.length > 0)
            setFavorTitleVisible(true);
        if (data.campaign?.length > 0)
            setCampaignTitleVisible(true);
    }

    const hasPackage = () => {
        return hasPackages(user);
    }

    const getEndSessionDialogContent = () => {
        if (hasInternetPackageUnlimited()) return t('home.endsession_connection_content');
        return hasPackage() ? ((qoutaRemainingMB === '-' ? '' : (t('home.your_estimated_remaining_quota') + ": <b>" + qoutaRemainingMB + " MB</b><br/>"))
            + t('home.endsession_connection_content')) : '';
    }

    const isLoginMilesSmiles = () => {
        return ((user?.verifyType === VerifyTypeEnum.MILES_A_SMILES || user?.verifyType === VerifyTypeEnum.FORGOT_PASSCODE) || user?.package !== null)
    }

    const isLoginOtherLogin = () => {
        return (user?.verifyType === VerifyTypeEnum.OTHER_LOGIN)
    }

    const handleStopInternet = () => {
        setLoading(true);
        setDisconnectVisible(false);
        setTimeout(() => {
            setLoading(false);
            getQuotaRemaining(true);
            setResumeInternetVisible(true);
            simulationNumber(7, 4);
        }, 1000);
        //setDisconnectExceptionVisible(true);
    }

    const handleResumeInternet = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            getQuotaRemaining(true);
            setResumeInternetVisible(false);
            simulationNumber(8, 4);
        }, 1000);
        //setResumeExceptionVisible(true);
    }

    const handleEndUserSession = () => {
        setLoading(true);
        setEndSessionVisible(false);
        setTimeout(() => {
            setLoading(false);
            navigate("/login");
        }, 1000);
        //setEndSessionExceptionVisible(true);
    }

    const openTurkishAirlinesWebSite = () => {
        window.open(Const.TURKISH_AIRLINES_URL, '_blank', 'noopener, noreferrer');
    }

    const openFeedbackForm = () => {
        navigate('/feedback', {state: 'remaining'})
    }

    const showPopupFeedback = () => {
        setDialogDynamic({
            visible: true,
            icon: ICON_TYPE.STARS,
            title: t('feedback.internet_service_satisfaction_survey'),
            content: t('feedback.popup_content'),
            confirm: {
                label: t('feedback.evaluate_btn'), click: (dialogDynamic) => {
                    dialogDynamic({visible: false});
                    navigate('/feedback', {state: 'remaining'})
                }
            },
            cancel: {
                label: t('home.close'), click: (dialogDynamic) => {
                    dialogDynamic({visible: false});
                }
            }
        });
    }

    const getTextToContinueUsing = () => {
        if (/tr/.test(i18n.language.toLowerCase())) {
            return ("<span><b>\"" + t('home.resume_connection') + "\"</b> " + t('home.to_continue_using') + "</span>");
        } else {
            return ("<span>" + t('home.to_continue_using') + " <b>\"" + t('home.resume_connection') + "\"</b></span>")
        }
    }

    const getCard = (visible, title, packages) => {
        return (
            <>
                {visible && (
                    <div className="package-title-root">
                        <p className="package-title">{title}</p>
                    </div>
                )}
                {packages}
            </>);
    }

    return (
        <div>
            <HeaderComponent
                title={t('home.title') + " " + firstCharacterUpper(user?.name) + (user?.name ? ',' : '')}
                content={getContentManager().homeContent()}/>

            {!hasPackage() && (
                <div className="content-root no-package-root">

                    <img className="no-package-img" alt={"no package"} src={NoPackageIcon}/>

                    <p className="no-package-text">{t('home.no_package_text')}</p>

                    <p className="no-package-desc">{
                        isLoginMilesSmiles() ?
                            (parse(t('home.no_package_desc_login'))) :
                            (parse(flight.domestic ? t('home.no_package_desc_domestic') : t('home.no_package_desc')))
                    }</p>

                    <div className="h-4"/>

                </div>
            )}

            {hasPackage() && (
                <div className="content-root">

                    <div className="package-title-root m-t-0">
                        <p className="package-title">{t('home.your_remaining_rights')}</p>
                    </div>

                    <OnboardTotalQouta qoutaRemainingMB={qoutaRemainingMB}
                                       black={user?.business}
                                       qoutaRemainingTotalMB={qoutaRemainingTotalMB}
                                       isUnlimitedMessage={qoutaIsUnlimitedMessage}
                                       isUnlimitedInternet={qoutaIsUnlimitedInternet}
                                       qoutaRemainingTime={qoutaRemainingTime}
                                       loading={qoutaLoading}/>

                    {getCard(definedTitleVisible, t('home.defined_rights'), renderDefinedRightsPackages())}

                    {getCard(favorTitleVisible, t('home.favor_package'), renderFavorPackages())}

                    {getCard(campaignTitleVisible, t('home.campaign_package'), renderCampaignPackages())}

                    {getCard(purchaseTitleVisible, t('home.purchased_package'), renderPurchasePackages())}

                    <div className="h-4"/>

                </div>
            )}

            <div className="content-root">

                {(!isLoginMilesSmiles() && !isLoginOtherLogin()) && (
                    <span>
                        <OnboardButton label={t('home.login_or_register')} onClick={() => navigate("/login-offer")}/>

                        <OnboardOrLine/>
                    </span>
                )}

                {handlePackageBuyButtonVisible() && (
                    <OnboardButton outline={!isLoginMilesSmiles()} label={t('home.package_buy')}
                                   onClick={() => navigate("/purchase-package")}/>
                )}

                {handlePurchaseButtonVisible() && !qoutaLoading && hasPackage() && qoutaRemainingMB !== 0 && !resumeInternetVisible && (
                    <OnboardButton outlineBlack
                                   label={t('home.disconnect_connection')}
                                   onClick={() => setDisconnectVisible(true)}/>
                )}

                {handlePurchaseButtonVisible() && !qoutaLoading && hasPackage() && resumeInternetVisible && (
                    <OnboardButton blue
                                   label={t('home.resume_connection')}
                                   onClick={() => handleResumeInternet()}/>
                )}

                <OnboardButton black={hasPackage()} outlineBlack={!hasPackage()}
                               label={t('logout')}
                               onClick={() => setEndSessionVisible(true)}/>

                <OnboardTwoButtons
                    leftLabel={t('home.turkish_airlines_web_site')}
                    rightLabel={t('feedback.evaluate_our_service')}
                    onClickLeft={openTurkishAirlinesWebSite}
                    onClickRight={openFeedbackForm}
                />

                {/*<OnboardButton gray label={t('promotion_code_page.use_promotion_code')}*/}
                {/*               onClick={() => navigate("/promotion-code")}/>*/}
            </div>

            <FooterComponent/>

            <OnboardDialog infoIcon visible={warningVisible}
                           title={t('home.disconnect_popup_title')}
                           content={t('home.disconnect_popup_content')}
                           moveCancelAndConfirm
                           confirmText={t('home.got_it')}
                           confirmShow={location.pathname !== '/simulation'}
                           onClickConfirm={() => {
                               setWarningVisible(false);
                           }}
                           cancelText={t('home.how_can_i_do_it')} cancelShow
                           onClickCancel={() => {
                               setWarningVisible(false);
                               setInformationVisible(true);
                           }}
            />

            <OnboardDialog warningIcon visible={disconnectVisible} directingCancel
                           title={t('home.disconnect_connection_title')}
                           content={(qoutaRemainingMB === '-' ? '' : (t('home.your_estimated_remaining_quota') + ": <b>" + qoutaRemainingMB + " MB</b><br/>"))
                               + getTextToContinueUsing()}
                           confirmText={t('home.disconnect_connection')} confirmShow
                           onClickConfirm={() => {
                               handleStopInternet();
                           }}
                           cancelShow
                           cancelText={t('cancel')}
                           onClickCancel={() => setDisconnectVisible(false)}
            />

            <OnboardDialog warningIcon visible={endSessionVisible} directingCancel
                           title={hasPackage() ? t('home.endsession_connection_title') : t('home.logout_connection_title')}
                           content={getEndSessionDialogContent()}
                           confirmText={t('logout')}
                           onClickConfirm={() => handleEndUserSession()} confirmShow
                           cancelShow
                           cancelText={t('cancel')}
                           onClickCancel={() => setEndSessionVisible(false)}
            />

            <OnboardDialog error visible={disconnectExceptionVisible} directingCancel
                           title={t('home.disconnect_connection_error')}
                           cancelShow cancelText={t('home.close')}
                           onClickCancel={() => {
                               setDisconnectExceptionVisible(false);
                           }}
            />

            <OnboardDialog error visible={endSessionExceptionVisible} directingCancel
                           title={t('home.endsession_connection_error')}
                           cancelShow cancelText={t('home.close')}
                           onClickCancel={() => {
                               setEndSessionExceptionVisible(false);
                           }}
            />

            <OnboardDialog error visible={resumeExceptionVisible} directingCancel
                           title={t('home.resume_connection_error')}
                           cancelShow cancelText={t('home.close')}
                           onClickCancel={() => {
                               setResumeExceptionVisible(false);
                           }}
            />

            <PowerSavingModeIntroductionComponent t={t} visible={informationVisible} i18n={i18n} location={location}/>
        </div>
    );
};

export default RemainingUsagePage;
